module.exports = __webpack_public_path__ + "c4711a3995f11e12a861cb8f7133c38f.png";